import { FC } from 'react';
import { Link } from '@base/lib/Link';
import { LoopRender } from '@base/snippets/LoopRender';
import { helpGroupsWithProducts } from 'pro/config/help';
import { RouteEnum } from 'pro/config/routers';
import { generatePath } from 'ava-util/dist/request';

const transLink = (link: string) => {
    return link === RouteEnum.CONTACT ? generatePath(RouteEnum.CONTACT, { from: 'Footer Navigation' }) : link;
}

export const FooterNav: FC = () => {
    return (
        <ul>
            <LoopRender list={helpGroupsWithProducts} render={item => (
                <li className={'mb-16 text-38'}>
                    <Link href={transLink(item.link)}>
                        {item.title}
                    </Link>
                </li>
            )}/>
        </ul>
    )
};
